import { useLocalSearchParams } from 'expo-router';

import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  const { giftCardId } = useLocalSearchParams<{ giftCardId: string }>();

  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>
        Gift Card Redemption — {giftCardId}
      </ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
